import { createContext, useState, ReactNode, useEffect } from "react";

export const languagesArr = ["en", "ro"] as const;
export type LanguageType = (typeof languagesArr)[number];

export const translateMap = {
  "home-hero-h1": {
    ro: "Simplifică-ți munca. Găsește totul într-un singur loc.",
    en: "Simplify your work. Find everything in one place.",
  },
  "home-hero-p": {
    ro: "Cu OMNIA360, ai răspunsuri instant și control complet asupra proceselor interne.",
    en: "With OMNIA360, you have instant answers and complete control over internal processes.",
  },
  "home-hero-button": {
    ro: "Solicită un demo",
    en: "Request a demo",
  },
  "home-hero-available": {
    ro: "Aplicația este disponibilă acum",
    en: "The app is now available",
  },
  "home-hero-feature-1": {
    ro: "Concedii",
    en: "Leaves",
  },
  "home-hero-feature-2": {
    ro: "Prezență",
    en: "Attendance",
  },
  "home-hero-feature-3": {
    ro: "Documente",
    en: "Documents",
  },
  "home-hero-feature-4": {
    ro: "Resurse",
    en: "Resources",
  },
  "home-hero-feature-5": {
    ro: "Aprobări",
    en: "Approvals",
  },
  "home-hero-feature-6": {
    ro: "Salarii",
    en: "Salaries",
  },

  "home-hero-feature-7": {
    ro: "Dosar",
    en: "Dossary",
  },
  "home-hero-feature-8": {
    ro: "Echipa",
    en: "Team",
  },
  "home-components-title": {
    ro: "Componentele OMNIA360",
    en: "OMNIA360 Components",
  },
  "home-components-subtitle": {
    ro: "Tot ce ai nevoie pentru o experiență HR completă, integrată într-o singură platformă.",
    en: "Everything you need for a complete HR experience, integrated into one platform.",
  },
  "home-components-feature-1": {
    ro: "Concedii",
    en: "Leaves",
  },
  "home-components-feature-1-description": {
    ro: "Depunere rapidă de cereri, aprobare transparentă și calendar organizat.",
    en: "Quick request submission, transparent approval, and organized calendar.",
  },
  "home-components-feature-2": {
    ro: "Prezență & Pontaj",
    en: "Attendance & Time Tracking",
  },

  "home-components-feature-2-description": {
    ro: "Pontaj zilnic, evidența pauzelor și ore lucrate.",
    en: "Daily time tracking, break records, and hours worked.",
  },
  "home-components-feature-3": {
    ro: "Documente HR",
    en: "HR Documents",
  },
  "home-components-feature-3-description": {
    ro: "Adeverințe și cereri eliberate automat sau prin aprobare.",
    en: "Certificates and requests issued automatically or through approval.",
  },
  "home-components-feature-4": {
    ro: "Resurse angajat",
    en: "Employee Resources",
  },
  "home-components-feature-4-description": {
    ro: "Fișa de angajare și lichidare disponibile oricând.",
    en: "Employment and termination records available anytime.",
  },
  "home-components-feature-5": {
    ro: "Echipamente",
    en: "Equipment",
  },
  "home-components-feature-5-description": {
    ro: "Inventar digitalizat al echipamentelor proprii.",
    en: "Digitized inventory of your equipment.",
  },
  "home-components-feature-6": {
    ro: "Salarii & Contracte",
    en: "Salaries & Contracts",
  },
  "home-components-feature-6-description": {
    ro: "Fluturași și contracte disponibile digital în siguranță.",
    en: "Payslips and contracts available digitally and securely.",
  },
  "home-components-feature-7": {
    ro: "Dosar personal",
    en: "Personal Dossier",
  },
  "home-components-feature-7-description": {
    ro: "Toate documentele ce țin de relația angajatului cu angajatorul.",
    en: "All documents related to the employee's relationship with the employer.",
  },
  "home-components-feature-8": {
    ro: "Sarcini",
    en: "Tasks",
  },
  "home-components-feature-8-description": {
    ro: "Vizualizarea listei de sarcini de efectuat de către angajat și bifarea lor atunci când au fost efectuate.",
    en: "View the list of tasks to be performed by the employee and check them off when completed.",
  },
  "home-ai-title": {
    ro: "Asistentul Inteligent Omnia360",
    en: "Omnia360 Intelligent Assistant",
  },
  "home-ai-subtitle": {
    ro: "Răspunde instant. Execută acțiuni. Ghidul tău personal, 24/7.",
    en: "Instant responses. Executes actions. Your personal guide, 24/7.",
  },
  "home-ai-feature-1": {
    ro: "Chat intuitiv, prietenos și disponibil non-stop",
    en: "Intuitive, friendly chat available 24/7",
  },
  "home-ai-feature-2": {
    ro: "Rezervă concedii la o simplă cerere",
    en: "Book leaves with a simple request",
  },
  "home-ai-feature-3": {
    ro: "Înregistrează automat sosirea sau plecarea",
    en: "Automatically records arrival or departure",
  },
  "home-ai-feature-4": {
    ro: "Generează cereri și adeverințe în timp real",
    en: "Generates requests and certificates in real-time",
  },

  "home-ai-feature-5": {
    ro: "Oferă explicații despre orice funcționalitate",
    en: "Provides explanations about any functionality",
  },
  "home-ai-feature-6": {
    ro: "Te ghidează spre datele tale esențiale",
    en: "Guides you to your essential data",
  },

  "footer-pp": {
    ro: "Politica de confidențialitate",
    en: "Privacy Policy",
  },
  "footer-rights": {
    ro: "Omnia360. Toate drepturile rezervate.",
    en: "Omnia360. All rights reserved.",
  },
  "privacy-title": {
    ro: "Politica de Confidențialitate",
    en: "Privacy Policy",
  },
  "privacy-last-updated": {
    ro: "Ultima actualizare: 28.06.2025",
    en: "Last updated: 28.06.2025",
  },
  "privacy-1-title": {
    ro: "Operatorul de date",
    en: "Data Controller",
  },
  "privacy-1-body": {
    ro: `
    <strong>⁠Operatorul de date</strong>
    <strong>Nume:</strong> Vlad Roșu<br/>
       <strong>Adresă:</strong> București, România<br/>
       <strong>Email de contact:</strong> <img src="/email.png" class="w-44" style="display : inline-block; user-select: none;"/>`,
    en: `<strong>Name:</strong> Vlad Roșu<br/>
       <strong>Address:</strong> Bucharest, Romania<br/>
       <strong>Contact email:</strong> <img src="/email.png" class="w-44" style="display : inline-block; user-select: none;"/>`,
  },
  "privacy-2-title": {
    ro: "Ce date colectăm",
    en: "What data we collect",
  },
  "privacy-2-body": {
    ro: "Singura informație personală colectată este numărul de telefon, oferit de utilizator în mod voluntar pentru utilizarea aplicației.",
    en: "The only personal information collected is the phone number, provided voluntarily by the user to use the app.",
  },
  "privacy-3-title": {
    ro: "Scopul colectării datelor",
    en: "Purpose of data collection",
  },
  "privacy-3-body": {
    ro: `Numărul de telefon este colectat exclusiv pentru:
       <ul class="list-disc list-inside mt-2">
         <li>Crearea unui cont sau identificarea utilizatorului în aplicație.</li>
         <li>Furnizarea funcționalităților aplicației.</li>
       </ul>
       <p class="mt-2">Nu folosim datele pentru marketing sau publicitate.</p>`,
    en: `The phone number is collected exclusively for:
       <ul class="list-disc list-inside mt-2">
         <li>Creating an account or identifying the user in the app.</li>
         <li>Providing the app's functionalities.</li>
       </ul>
       <p class="mt-2">We do not use the data for marketing or advertising.</p>`,
  },
  "privacy-4-title": {
    ro: "Ce nu colectăm",
    en: "What we do not collect",
  },
  "privacy-4-body": {
    ro: `<ul class="list-disc list-inside">
         <li>Nu colectăm locația utilizatorului.</li>
         <li>Nu avem acces la contacte, cameră sau alte funcții ale telefonului.</li>
         <li>Nu trimitem newslettere sau mesaje promoționale.</li>
         <li>Nu folosim instrumente de analiză sau urmărire.</li>
         <li>Nu folosim cookie-uri, pixeli sau retargeting.</li>
         <li>Nu există reclame în aplicație.</li>
         <li>Nu permitem autentificarea prin rețele sociale.</li>
       </ul>`,
    en: `<ul class="list-disc list-inside">
         <li>We do not collect the user's location.</li>
         <li>We do not have access to contacts, camera, or other phone functions.</li>
         <li>We do not send newsletters or promotional messages.</li>
         <li>We do not use analytics or tracking tools.</li>
         <li>We do not use cookies, pixels, or retargeting.</li>
         <li>There are no ads in the app.</li>
         <li>We do not allow social media authentication.</li>
       </ul>`,
  },
  "privacy-5-title": {
    ro: "Cui partajăm datele",
    en: "Who we share data with",
  },
  "privacy-5-body": {
    ro: "Nu partajăm, vindem sau închiriem informațiile personale către terți.",
    en: "We do not share, sell, or rent personal information to third parties.",
  },
  "privacy-6-title": {
    ro: "Securitatea datelor",
    en: "Data security",
  },
  "privacy-6-body": {
    ro: `Datele sunt stocate în siguranță și protejate prin măsuri tehnice și organizatorice adecvate. 
       Nu transmitem datele către terți fără consimțământul utilizatorului, cu excepția cazurilor legale.`,
    en: `Data is stored securely and protected by appropriate technical and organizational measures.
       We do not transmit data to third parties without the user's consent, except in legal cases.`,
  },
  "privacy-7-title": {
    ro: "Drepturile utilizatorului",
    en: "User rights",
  },
  "privacy-7-body": {
    ro: `Utilizatorii au dreptul să:
       <ul class="list-disc list-inside mt-2">
         <li>Acceseze datele personale colectate.</li>
         <li>Solicite corectarea sau ștergerea datelor.</li>
         <li>Se opună prelucrării datelor în anumite condiții.</li>
         <li>Solicite restricționarea prelucrării datelor.</li>
         <li>Solicite portabilitatea datelor.</li>
       </ul>
       <p class="mt-2 inline-block">Pentru exercitarea acestor drepturi, ne puteți contacta la  <img class="w-44" src="/email.png" style="display : inline-block; user-select: none;"/>   
                  </ul>`,
    en: `Users have the right to:
       <ul class="list-disc list-inside mt-2">
         <li>Access the personal data collected.</li>
         <li>Request correction or deletion of data.</li>
         <li>Object to data processing under certain conditions.</li> 
          <li>Request restriction of data processing.</li>
          <li>Request data portability.</li>
        </ul>
        <p class="mt-2 inline-block">To exercise these rights, you can contact us at:  
<img class="w-44" src="/email.png" style="display : inline-block; user-select: none;"/>                  </ul>`,
  },
  "privacy-8-title": {
    ro: "Vârsta minimă",
    en: "Minimum age",
  },
  "privacy-8-body": {
    ro: "Aplicația nu este destinată utilizatorilor sub 13 ani. Nu colectăm intenționat informații de la minori.",
    en: "The app is not intended for users under 13 years old. We do not intentionally collect information from minors.",
  },
  "privacy-9-title": {
    ro: "Modificări ale politicii",
    en: "Policy changes",
  },
  "privacy-9-body": {
    ro: `Această politică poate fi actualizată. Vom notifica utilizatorii despre modificări prin aplicație sau prin email, dacă este cazul.`,
    en: `This policy may be updated. We will notify users of changes through the app or by email, if applicable.`,
  },
  "benefits-title": {
    ro: "Avantaje și Beneficii",
    en: "Benefits and Advantages",
  },
  "benefits-tab-users": {
    ro: "Utilizatori",
    en: "Users",
  },
  "benefits-tab-employers": {
    ro: "Angajatori",
    en: "Employers",
  },
  "benefits-user-1": {
    ro: "Interfață intuitivă și ușor de folosit",
    en: "Intuitive and easy-to-use interface",
  },
  "benefits-user-1-desc": {
    ro: "Aplicație pentru telefonul mobil, pe care angajații învață imediat să o utilizeze.",
    en: "Mobile app that employees quickly learn to use.",
  },
  "benefits-user-2": {
    ro: "Acces rapid la informații personale și documente",
    en: "Quick access to personal data and documents",
  },
  "benefits-user-2-desc": {
    ro: "Toate datele importante sunt disponibile imediat, fără a mai depinde de departamentul HR.",
    en: "All important data is available immediately, without relying on the HR department.",
  },
  "benefits-user-3": {
    ro: "Solicitări procesate instant prin chat AI",
    en: "Requests handled instantly through AI chat",
  },
  "benefits-user-3-desc": {
    ro: "Angajații își generează documentele și primesc răspunsuri la întrebări în câteva secunde, direct din aplicație.",
    en: "Employees generate their documents and receive answers to questions in seconds, directly from the app.",
  },
  "benefits-employer-1": {
    ro: "Control centralizat al resurselor umane",
    en: "Centralized control over HR processes",
  },
  "benefits-employer-1-desc": {
    ro: "Managerii le oferă angajaților un instrument unic de HR și obțin controlul centralizat al fluxurilor de resurse umane.",
    en: "Managers provide employees with an unique HR tool and gain centralized control over HR workflows.",
  },
  "benefits-employer-2": {
    ro: "Reducerea timpului administrativ",
    en: "Reduced administrative workload",
  },
  "benefits-employer-2-desc": {
    ro: "Procesele HR repetitive sunt automatizate, și echipa de resurse umane câștigă timp pentru activități manageriale.",
    en: "Repetitive HR processes are automated, and the HR team gains time for managerial activities.",
  },
  "benefits-employer-3": {
    ro: "Transparență și trasabilitate în aprobări",
    en: "Transparency and traceability in approvals",
  },
  "benefits-employer-3-desc": {
    ro: "Toate solicitările și aprobările sunt înregistrate în sistem, cu detalii complete despre cerințe.",
    en: "All requests and approvals are recorded in the system, with complete details about the requirements.",
  },
  "contact-title": {
    ro: "Contactează-ne",
    en: "Contact Us",
  },
  "contact-subtitle": {
    ro: "Ai întrebări sau sugestii? Suntem aici să te ajutăm!",
    en: "Have questions or suggestions? We're here to help!",
  },
  "contact-name": {
    ro: "Nume și prenume *",
    en: "First and last name *",
  },
  "contact-name-placeholder": {
    ro: "Introdu numele tău",
    en: "Enter your name",
  },
  "contact-email": {
    ro: "Email *",
    en: "Email *",
  },
  "contact-email-placeholder": {
    ro: "Introdu adresa ta de email",
    en: "Enter your email address",
  },
  "contact-message": {
    ro: "Mesaj",
    en: "Message ",
  },
  "contact-message-placeholder": {
    ro: "Scrie mesajul tău aici",
    en: "Write your message here",
  },
  "contact-submit": {
    ro: "Solicită un demo Omnia360",
    en: "Request an Omnia360 demo",
  },
  "contact-phone": {
    ro: "Număr de telefon *",
    en: "Phone number *",
  },
  "contact-company": {
    ro: "Companie *",
    en: "Company *",
  },
  "contact-phone-placeholder": {
    ro: "Introdu numărul tău de telefon",
    en: "Enter your phone number",
  },
  "contact-company-placeholder": {
    ro: "Introdu numele companiei tale",
    en: "Enter your company name",
  },
  "solve-captcha": {
    ro: "Rezolvă CAPTCHA",
    en: "Solve the CAPTCHA",
  },
  "message-sent": {
    ro: "Mesaj trimis!",
    en: "Message sent!",
  },
  "thank-you-for-message": {
    ro: "Mulțumim pentru mesaj! Te vom contacta în curând.",
    en: "Thank you for your message! We will get back to you soon.",
  },
};

export type TranslateKey = keyof typeof translateMap;

type LanguageContextType = {
  language: LanguageType;
  setLanguage: (language: LanguageType) => void;
  t: (key: TranslateKey) => string;
};

export const LanguageContext = createContext<LanguageContextType>({
  language: "ro",
  setLanguage: () => {},
  t: () => "",
});

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<LanguageType>("ro");

  useEffect(() => {
    const lang = localStorage.getItem("language") as LanguageType | null;
    if (lang === "ro" || lang === "en") {
      setLanguage(lang);
    }
  }, []);

  const updateLanguage = (lang: LanguageType) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
  };

  const t = (key: TranslateKey) => {
    return translateMap[key][language];
  };

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage: updateLanguage, t }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
